import { PartenariatsPageLexique } from 'locales/types/containers/partenariatsPage';

export const partenariatsPageLexique: PartenariatsPageLexique = {
    headTitle: 'Partenariats',
    concernedPeriod: 'Periode concernée',
};

export default partenariatsPageLexique;
